const styles = {
  planDescription: {
    mb: 2,
  },
  warningText: {
    color: "black",
    fontSize: 13,
    mt: 2,
  },
  textContainer: {
    mb: { xs: 0, md: 1 },
  },
  chip: {
    ml: 1,
    color: "inherit",
    borderRadius: 2,
  },
  strike: {
    textDecoration: "line-through",
    color: "info.main",
    opacity: 0.5,
  },
  moneyBack: {
    backgroundColor: "secondary.light",
    width: "max-content",
    fontSize: 12,
    p: 1,
    py: 0.5,
    borderRadius: 2,
  },
  discount: {
    color: "success.main",
    fontSize: 12,
    mt: 1,
    fontWeight: 600,
  },
};

export default styles;
